import React from "react"
import "./description-category-events.scss"

import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const DescriptionCategoryProducts = props => {
  const { generalDescription } = props
  return (
    <div className="a-description-category">
      <div className="a-description-category-content">
        {documentToReactComponents(generalDescription.json)}
      </div>
    </div>
  )
}

export default DescriptionCategoryProducts
